import { BaserowPlugin } from '@baserow/modules/core/plugins'
import Impersonate from '@baserow_premium/components/sidebar/Impersonate'
import PremiumViewOptions from '@baserow_premium/components/views/PremiumViewOptions'
import PublicViewExportMenuItem from '@baserow_premium/components/views/PublicViewExportMenuItem'

export class PremiumPlugin extends BaserowPlugin {
  static getType() {
    return 'premium'
  }

  getImpersonateComponent() {
    return Impersonate
  }

  // Unlocked fork: no license badge in the sidebar. Every license type is
  // always reported active, so the chip conveyed nothing and its tooltip
  // referred to license validity that no longer applies.
  getHighestLicenseTypeBadge() {
    return null
  }

  getAdditionalShareLinkOptions() {
    return [PremiumViewOptions]
  }

  getAdditionalPublicViewMenuItems(view) {
    return view.allow_public_export ? [PublicViewExportMenuItem] : []
  }

  hasFeature(feature, forSpecificWorkspace) {
    return this.app.$licenseHandler.hasFeature(feature, forSpecificWorkspace)
  }

  /**
   * A hook to provide different action buttons to the premium features modal.
   */
  getPremiumModalButtonsComponent() {
    return null
  }
}
